export default {
  en: {
    default: 'There was an error submitting the form, please try again',
  },
  fr: {
    default: "Une erreur s'est produite lors de l'envoi du formulaire",
  },
};
